import * as angular from 'angular';

import { ComponentDefinition, Group } from '../../models';
import { IGroupStatesWidgetService, IDateRangeService } from '../../services';
import { refreshClick, groupSelected } from '../../common';
import { GroupStateResults } from '../../widgets';
import { GroupStatesWidget } from './groupStates.widget';
import { GroupStateConfiguration } from './groupStates.configuration';
import { ListGroupStateResults } from '../models';

class GroupStatesController implements angular.IComponentController {
    data: GroupStateResults[];
    isLoading: boolean;
    item: GroupStatesWidget;
    loadingMessage: string;

    readonly boundData: ListGroupStateResults;
    readonly isBound: boolean;
    readonly groups: Group[];
    readonly series: any[];

    private _series: any[];

    static $inject = [
        '$scope',
        'groupStatesWidgetService',
        'dateRangeService'
    ];

    constructor(
        private $scope: angular.IScope,
        private _groupStatesWidgetService: IGroupStatesWidgetService,
        private _dateRangeService: IDateRangeService
    ) {
    }

    $onInit() {
        if (!this.item.configuration.options) {
            this.item.configuration.options = {};
        }
        const watchersAndHandlers: (() => void)[] = [];
        if (!this.boundData) {
            watchersAndHandlers.push(this.$scope.$watch(() => this.item.configuration.series, (newValue) => {
                if (newValue) {
                    this.refresh(newValue, true);
                }
            }, true));
            watchersAndHandlers.push(this.$scope.$on(refreshClick, () => this.tryRefresh()));
            watchersAndHandlers.push(this.$scope.$on(groupSelected, () => this.tryRefresh()));
        } else {
            while (watchersAndHandlers.length) {
                const popped = watchersAndHandlers.pop();
                popped();
            }
            if (!this.isBound) {
                this.$scope.$watch(() => this.item.configuration.series, () => this.tryRefresh(false), true);
                this.$scope.$on(groupSelected, () => this.tryRefresh(false));
            } else {
                this.$scope.$watch(() => this.series, () => {
                    if (this.boundData) {
                        this.data = this._groupStatesWidgetService
                            .map(this.series, this.boundData.groupStatesResults, this.boundData.states);
                    }
                });
            }
            this.$scope.$watch(() => this.boundData, () => {
                const series = this.series ? this.series : this._series;
                if (series) {
                    this.data = this._groupStatesWidgetService
                        .map(series, this.boundData.groupStatesResults, this.boundData.states);
                }
            });
        }

        this.tryRefresh(false);
    }

    private tryRefresh(updateData: boolean = true) {
        const configSeries = this.series || this.item.configuration.series;
        if (configSeries) {
            this.refresh(configSeries, updateData);
        }
    }

    refresh(series: GroupStateConfiguration[], updateData: boolean) {
        this.isLoading = true;
        this._groupStatesWidgetService
            .getViewModels(series, this.groups)
            .then(data => {
                this.isLoading = false;
                this.update(data, updateData);
            })
            .catch(() => this.isLoading = false);
    }

    update(data: any[], updateData: boolean = false) {
        this._series = data;
        if (updateData) {
            this.refreshData();
        } else if (this.boundData.groupStatesResults) {
            this.data = this._groupStatesWidgetService
                .map(this._series, this.boundData.groupStatesResults, this.boundData.states);
        }
        if (this._series?.length > 0) {
            this.item.selectedGroupGuid = this._series[0].guid;
        }
    }

    refreshData() {
        if (this.item && this._series) {
            this.isLoading = true;
            const interval = this.item.getInterval(this._dateRangeService.beginDate() as string, this._dateRangeService
                .endDate() as string);
            this._groupStatesWidgetService
                .refresh(this._series, interval.beginMoment.toISOString(), interval.endMoment.toISOString())
                .then(data => this.data = data)
                .finally(() => this.isLoading = false);
        }
    }
}

export const wtGroupStates: ComponentDefinition = {
    componentId: 'wtGroupStates',
    controller: GroupStatesController,
    template: require('./groupStates.component.html'),
    controllerAs: 'vm',
    bindings: {
        boundData: '<?',
        groups: '<',
        isBound: '<?',
        item: '=',
        ratio: '<?',
        series: '<?'
    }
};